import { Box, Button, Container, Typography } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import { useState } from 'react'
import { InfoCardIcon } from 'components/atoms/Icons'
import LeadershipPathList from 'components/organisms/LeadershipPathList'
import { Trans, useTranslation } from 'react-i18next'
import improveXoIcon from 'assets/images/improveXo.svg'

const StepThree = ({ completeCallback, selectedGoal }) => {
  const { t } = useTranslation()
  const [activePage, setActivePage] = useState(0)

  const handleStartClick = () => {
    if (selectedGoal.id) {
      completeCallback()
    } else {
      setActivePage(1)
    }
  }

  const goalSelected = Boolean(selectedGoal?.id)
  return (
    <>
      {activePage === 0 ? (
        <InCardStack width={600} textAlign='center'>
          <Typography variant='h1' color='primary'>
            {goalSelected
              ? t('onboarding.yourLearningPath')
              : t('addRaters.startYourJourney')}
          </Typography>
          <Typography variant='body1Large'>
            {goalSelected ? (
              <Trans
                i18nKey='onboarding.welcomeToPath'
                values={{
                  goalName: selectedGoal.name,
                  leadershipName: selectedGoal.leadershipModelName
                }}
              />
            ) : (
              t('onboarding.getStartedOnLeadershipJourney')
            )}
          </Typography>
          <Typography variant='body1Large'>
            {goalSelected
              ? t('onboarding.pathSelectedForYou')
              : t('onboarding.seeDetailsLearningPaths')}
          </Typography>
          <Box paddingY={10}>
            <InfoCardIcon src={improveXoIcon} size={240} />
          </Box>
          <Button onClick={() => handleStartClick()}>
            {t('addRaters.getStarted')}
          </Button>
        </InCardStack>
      ) : activePage === 1 ? (
        <Container maxWidth='lg'>
          <InCardStack padding={10} spacing={4}>
            <Typography variant='h1' color='primary'>
              {t('leadership.monarkLeadershipModel')}
            </Typography>
            <Typography variant='body1Large' >
              {t('onboarding.selectYourPath')}
            </Typography>
          </InCardStack>
          <LeadershipPathList />
        </Container>
      ) : null}
    </>
  )
}

export default StepThree
